import { render, staticRenderFns } from "./comission-table.vue?vue&type=template&id=2011fb61"
import script from "./comission-table.vue?vue&type=script&lang=js"
export * from "./comission-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2011fb61')) {
      api.createRecord('2011fb61', component.options)
    } else {
      api.reload('2011fb61', component.options)
    }
    module.hot.accept("./comission-table.vue?vue&type=template&id=2011fb61", function () {
      api.rerender('2011fb61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/sales-comissions/comission-table.vue"
export default component.exports